import { schema } from '@wix/da-shared-react/pkg/redux/normalizr';
import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';
export const PapiNcMessageObjectSchema = new schema.Entity('nc_message', {
    originator: userSchema
}, {
    idAttribute: 'messageId'
});
